var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineCrossing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#FFEADC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9993 12C18.3675 12 18.666 12.2985 18.666 12.6667V23.3333C18.666 23.7015 18.3675 24 17.9993 24C17.6312 24 17.3327 23.7015 17.3327 23.3333V12.6667C17.3327 12.2985 17.6312 12 17.9993 12ZM13.8041 15.5286C14.0644 15.7889 14.0644 16.2111 13.8041 16.4714L12.9422 17.3333H15.3327C15.7009 17.3333 15.9993 17.6318 15.9993 18C15.9993 18.3682 15.7009 18.6667 15.3327 18.6667H12.9422L13.8041 19.5286C14.0644 19.7889 14.0644 20.2111 13.8041 20.4714C13.5437 20.7318 13.1216 20.7318 12.8613 20.4714L10.8613 18.4714C10.6009 18.2111 10.6009 17.7889 10.8613 17.5286L12.8613 15.5286C13.1216 15.2682 13.5437 15.2682 13.8041 15.5286ZM22.1946 15.5286C22.455 15.2682 22.8771 15.2682 23.1374 15.5286L25.1374 17.5286C25.3978 17.7889 25.3978 18.2111 25.1374 18.4714L23.1374 20.4714C22.8771 20.7318 22.455 20.7318 22.1946 20.4714C21.9343 20.2111 21.9343 19.7889 22.1946 19.5286L23.0565 18.6667H20.666C20.2978 18.6667 19.9993 18.3682 19.9993 18C19.9993 17.6318 20.2978 17.3333 20.666 17.3333H23.0565L22.1946 16.4714C21.9343 16.2111 21.9343 15.7889 22.1946 15.5286Z",
    fill: "#CD0606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineCrossing);
export default __webpack_public_path__ + "static/media/LineCrossing.fc1445f26e9a3697ef63d3c1e3c7c33a.svg";
export { ForwardRef as ReactComponent };